import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VoucherRepository } from '../../domain/repository/voucher.repository';
import { VoucherRegisterPayload } from '../../domain/models/voucher.model';
import { VOUCHER_REPOSITORY } from '../attachments.tokens';

@Injectable()
export class RegisterVoucherUseCase {
  constructor(@Inject(VOUCHER_REPOSITORY) private readonly repository: VoucherRepository) { }

  execute(payload: VoucherRegisterPayload): Observable<void> {
    return this.repository.register(payload);
  }
}
